import { apiPost, apiGet, apiPut, apiDelete } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const fetchEmployeesAPI = (data) => {
  return apiGet(`mgmt/employees`, data)
}

export const fetchAdminEmployeesAPI = (data) => {
  return apiGet(`mgmt/employees/admins`, data)
}

export const fetchEmployeesWithTermAPI = (term) => {
  return apiGet(`mgmt/employees?term=${term}`)
}

export const updateEmployeeAPI = (data) => {
  Hotjar.event('update_employee')
  return apiPost(`mgmt/employees/${data.id}`, data)
}

export const getInvitedEmployeeByTokenAPI = (token) => {
  var tokenData = {
    token: token,
  }
  Hotjar.event('invited_employee_token')
  return apiPost('mgmt/employee-invite/employee-info', tokenData)
}

export const createNewInviteEmployeeAPI = (invitation = {}) => {
  Hotjar.event('create_invite_employee')
  return apiPut('mgmt/employee-invite', invitation)
}

export const getTimeCardListAPI = () => {
  return apiGet('mgmt/timecards')
}

export const getTimecardsHistoryAPI = () => {
  return apiGet('mgmt/timecards/history')
}

export const updateTimecardAPI = (timecard) => {
  Hotjar.event('update_timecard')
  return apiPost(`mgmt/timecards/${timecard.id}`, timecard)
}

export const getRolesAPI = () => {
  return apiGet('mgmt/roles')
}

export const saveNewEmployeeAPI = (employee) => {
  Hotjar.event('save_employee')
  return apiPost('mgmt/employees', employee)
}

export const fetchEmployeeByIdAPI = (id) => {
  return apiGet(`mgmt/employees/${id}`)
}

export const deleteEmployeeAPI = (id) => {
  Hotjar.event('delete_employee')
  return apiDelete(`mgmt/employees/${id}`)
}

export const clockOutAPI = (id) => {
  Hotjar.event('clock_out')
  return apiDelete(`mgmt/timecards/${id}/admin`)
}

export const fetchInvitedEmployeesAPI = () => {
  return apiGet(`mgmt/employee-invite`)
}

export const resendInviteAPI = (inviteEmployeeId) => {
  return apiGet('mgmt/employee-invite/' + inviteEmployeeId + '/resendInviteEmployee')
}

export const createNewEmployeeByInviteAPI = (data) => {
  Hotjar.event('create_employee_by_invite')
  return apiPost('mgmt/employee-invite', data).then(({ data }) => data)
}

export const searchEmployeesAPI = (term) => {
  return apiGet(`mgmt/employees/search?term=${term}&limit=50&start=0`)
}



// WEBPACK FOOTER //
// ./src/api/employee.js